import { Link } from "react-router-dom";

export function NotFoundPage() {
  return (
    <div className="page page-not-found">
      <h1 className="page-title">Page not found</h1>
      <p className="text-muted">The page you&rsquo;re looking for doesn&rsquo;t exist.</p>
      <Link to="/dashboard" className="btn btn-primary">
        Back to dashboard
      </Link>
    </div>
  );
}
